import axios from 'axios';
import { findLastIndex } from 'lodash';
import React, { Component } from "react";

class FreedomPay extends Component{
    constructor(props){
        super(props);
        this.state= {
            loading: false, 
            Iframe: '',
            amount: props.amount
        }
        this.messageListener = this.messageListener.bind(this);
        this.loadIframe = this.loadIframe.bind(this);
        window.addEventListener('message', this.messageListener);

    }

    messageListener(e){
        console.log(e);
        if (!["https://hpc.uat.freedompay.com", "https://hpc.freedompay.com"].includes(e.origin) && e.origin.indexOf("10.10") < 0)
            return false;
        let message = e.data,
            data = message.data;
        if(message.type === 1){
            alert('The payment session has timed out. Please refresh and try again.');
            return ;
        }
        if(message.type === 3){
            const paymentAttributes = {};
            data.attributes.forEach((dataAttribute) => {
                paymentAttributes[dataAttribute.Key] = dataAttribute.Value;
            });
            console.log(data);
            let paymentKeyData = {
                attributes: paymentAttributes,
                paymentKeys: data.paymentKeys, 
                paymentType:  data.paymentType
            }
            console.log({sessionKey: this.state.sessionKey, paymentKeyData});
            this.props.doShopping({sessionKey: this.state.sessionKey, paymentKeyData});
        }
        if(message.type === 4){
            if(data.emittedBy === "Legal"){
                console.log("Emitting lessgal");
                this.props.handleChange({
                    target:{
                        name: 'acceptTerms',
                        value: message.isValid,
                        type: 'checkbox'
                    }
                });
            }
        }
        if(message.type === 15){
            if(data.id === "terms"){
                window.open(`/${this.props.locale}/terms`);
            }
            if(data.id === "privacy"){
                window.open(`/${this.props.locale}/privacy`);
            }
        }
    }

    loadIframe(){
        this.setState({loading:true, Iframe:''})
        const p = async ()=>{
            let context = {
                ...this.props.context
            };
            if(context.tokenInfo && (!context.tokenInfo.token || context.tokenInfo.token === 'manual')){
                context = {};
            }
            const res = await axios.post(`${process.env.GATSBY_BASE_API}/payments/init`, {
                ...context,
                amount: this.state.amount
            });
            this.setState({loading:false, Iframe: res.data.data.iframe, sessionKey: res.data.data.sessionKey});
        };
        p();
    }

    componentDidMount(){
        this.loadIframe();
    };

    componentWillUnmount(){
        window.removeEventListener('message', this.messageListener);
    }


    componentDidUpdate(prevProps, prevState){
        console.log(prevProps.context);
        console.log(this.props.context);
        if(!this.props.context || !this.props.context.tokenInfo){
            console.log("Returning");
             return;
        }
        if(this.props.context && !prevProps.context || this.props.context.tokenInfo && !prevProps.context.tokenInfo || this.props.context.tokenInfo.token !== prevProps.context.tokenInfo.token){
            console.log("reloadingIframe");
            this.loadIframe();
        }
    }

    render() {
        console.log(this.state.Iframe);

        return this.state.loading ? <></> : <div style={{display:'flex', minHeight:'610px', width:'100%'}} dangerouslySetInnerHTML={{__html: this.state.Iframe}} />;
    }
};
 
export default FreedomPay;
